"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0; // ARCHITECT-MIXINS [ FONT SIZE ] ##############################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. DEFAULTS ...............................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. COMPONENT ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

var _default = function _default(size) {
  switch (size) {
    case 'xxlarge':
      return "\n        font-size: var(--font-xxlarge-size);\n        line-height: var(--font-xxlarge-lineHeight);\n      ";

    case 'xlarge':
      return "\n        font-size: var(--font-xlarge-size);\n        line-height: var(--font-xlarge-lineHeight);\n      ";

    case 'large':
      return "\n        font-size: var(--font-large-size);\n        line-height: var(--font-large-lineHeight);\n      ";

    case 'medium':
      return "\n        font-size: var(--font-medium-size);\n        line-height: var(--font-medium-lineHeight);\n      ";

    case 'small':
      return "\n        font-size: var(--font-small-size);\n        line-height: var(--font-small-lineHeight);\n      ";

    default:
      return "\n        font-size: var(--font-normal-size);\n        line-height: var(--font-normal-lineHeight);\n      ";
  }
}; // 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports["default"] = _default;